import { Outlet } from "react-router";

const BasePageLayout = () => {
  return (
      <>
          <Outlet />
      </>
  );
};

export default BasePageLayout;